import React from "react";
import StatisticsDiv from "../../components/Statistics/StatisticsDiv";
import { routes } from "utilities/routing/generatedRoutes";

type FilterType = "review" | "draft" | "pending" | "overdue";

const ESignAgencyStatisticsDiv = ({ value }: { value: server.dto.ESignAgencyDashboard }) => {
  const onClick = (filterType: FilterType) => {
    let filterQs: string;
    switch (filterType) {
      case "draft": filterQs = "draft"; break;
      case "review": filterQs = "review"; break;
      case "pending": filterQs = "allPending"; break;
      case "overdue": filterQs = "pendingOverdue"; break;
    }

    // TODO: This is iffy because eSign documents can be made in different areas.
    const lifeCycleKey = "lifeCycle" satisfies keyof server.dto.ListDocumentInstruction;
    window.location.href = `${routes.contract_List().absolute}?${lifeCycleKey}=${filterQs}`;
  };

  return <div className="statistics-wrapper">

    <StatisticsDiv
      count={value.inDraft}
      label={RESX.DocumentLifeCycle.InDraft}
      color="darkgray"
      onClick={() => { onClick("draft"); }}
    />

    <StatisticsDiv
      count={value.inReview}
      label={RESX.DocumentLifeCycle.InReview}
      color="purple"
      onClick={() => { onClick("review"); }}
    />

    <StatisticsDiv
      count={value.inPending}
      label={RESX.DocumentLifeCycle.OutForSignature}
      color="orange"
      onClick={() => { onClick("pending"); }}
    />

    <StatisticsDiv
      count={value.inPendingOverDue}
      label={RESX.Financial.OverDue}
      color="red"
      onClick={() => { onClick("overdue"); }}
    />
  </div>;
};

export default ESignAgencyStatisticsDiv;